import "./index.css";
import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import ToastProvider from "./components/Toast";
// import MUIThemeProvider from '@/ThemeProvider/index.tsx';
import { ThemeProvider } from "@mui/material/styles";
import theme from "@/ThemeProvider/theme/theme";
import * as Sentry from "@sentry/react";
import store from "@/store";
import App from "@/App.tsx";

if (import.meta.env.VITE_SENTRY_ENVIRONMENT !== "localhost") {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_KEY,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    });
}

const root = createRoot(document.getElementById("root") as Element);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <ToastProvider>
                    <App />
                </ToastProvider>
            </ThemeProvider>
        </Provider>
    </React.StrictMode>,
);
